import React from "react";
import { Link, useLocation } from "react-router-dom";
import localeText from "../../../../../locale";

const StoreBreadcrumbs = () => {
  const location = useLocation();
  const pathname = location.pathname || "";

  if (!pathname.startsWith("/dashboard-store")) return null;

  const segments = pathname.replace("/dashboard-store", "").split("/").filter(Boolean);

  const getLabel = (segment) => {
    if (segment === "settings") return localeText("storeSettings");
    if (segment === "orders") return localeText("storeOrders");
    if (segment === "details") return localeText("storeOrderDetails") || localeText("orderDetails");
    if (segment === "products") return localeText("storeProducts");
    if (segment === "schedules") return localeText("storeSchedules");
    if (segment === "physical-store") return localeText("physicalStore");
    if (segment === "new") return localeText("addProduct");
    if (segment === "edit") return localeText("editProduct");
    if (/^\d+$/.test(segment)) return null;
    return segment;
  };

  const getPath = (index) => {
    const parts = ["/dashboard-store", ...segments.slice(0, index + 1)];
    if (parts[parts.length - 1] === "details") {
      return `${parts.slice(0, -1).join("/")}/details`;
    }
    return parts.join("/");
  };

  return (
    <nav
      className="flex align-items-center gap-2 mb-2 text-sm"
      style={{ color: "var(--theme-text-muted, #5C5C5C)" }}
      aria-label={localeText("breadcrumbsAriaLabel")}
    >
      {segments.length === 0 ? (
        <span style={{ color: "var(--theme-text, #171717)" }}>{localeText("store")}</span>
      ) : (
        <>
          <Link to="/dashboard-store" style={{ color: "var(--theme-text-muted)" }}>
            {localeText("store")}
          </Link>
          {segments.map((segment, index) => {
            const isLast = index === segments.length - 1;
            const label = getLabel(segment);
            if (!label) return null;
            const path = getPath(index);
            return (
              <React.Fragment key={path}>
                <span>/</span>
                {isLast ? (
                  <span style={{ color: "var(--theme-text, #171717)" }}>{label}</span>
                ) : (
                  <Link to={path} style={{ color: "var(--theme-text-muted)" }}>
                    {label}
                  </Link>
                )}
              </React.Fragment>
            );
          })}
        </>
      )}
    </nav>
  );
};

export default StoreBreadcrumbs;
